import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { CfopsDevolucaoComponent } from './cfops-devolucao.component';
import { CfopsDevolucaoEditComponent } from './cfops-devolucao-edit/cfops-devolucao-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [CfopsDevolucaoComponent, CfopsDevolucaoEditComponent]
})
export class CfopsDevolucaoModule { }
